import React from 'react';

/**
 * CompanySelection Component
 * Renders radio buttons for selecting a company.
 * Props:
 *  - state: form state object
 *  - handleChange: input change handler
 */
const CompanySelection = ({ state, handleChange }) => {
  // List of companies to render dynamically
  const companies = [
    { id: "Authorize.net", label: "Authorize.net" },
    { id: "CyberSource", label: "CyberSource" },
  ];

  return (
    <div className="row mt-3">
      {/* Section Title */}
      <div className="col-12">
        <p>Company</p>
      </div>

      {/* Radio buttons for company selection */}
      <div className="col-3 d-flex gap-5 align-items-center">
        {companies.map(({ id, label }) => (
          <div className="radio" key={id}>
            <input
              id={id}
              type="radio"
              name="company"
              value={id}
              checked={state.company === id}
              onChange={handleChange}
              autoComplete="off"
            />
            <label htmlFor={id}>{label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanySelection;
